import React, { Component, Fragment, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import SelectorInput from '../Shared/SelectorInput'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import { isAllowedToViewComponent } from '../../utils/helpers'

import AttachedFilesBox from '../Shared/AttachedFilesBox'
import ModalAddFile from '../Shared/ModalAddFile'
import Comentarios from '../Shared/Comentarios'

import { showModalSelector, selectFromSelector, getParameterByName } from '../../actions/common'

import {
    getSolicitud,
    updateInputs,
    addFile,
    removeFiles,
    addSolicitudBienesItem,
    removeSolicitudBienesItem,
    enviarComentario,
    editarComentario,
    eliminarComentario
} from '../../actions/solicitudbi'

class SolicitudBI extends Component {


    componentWillMount() {
        this.props.getParameterByName('UNIDADES')
    }    

    handleOpenSelector = (list) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'descripcion', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = list
            payload.value = a


            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1', payload)

            const estado = this.props.solicitudBI.get('estado')

            if (estado == 8) {
                this.props.updateInputs('addModificacion', true)
            }

        }
        this.props.showModalSelector('Listado de bienes', columns, '/solicitudes/bienes-investigacion/erp_items', fn)
    }

    handleOpenSelectorResponsable = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/auxiliares', fn)
    }

    modificarSolicitud = (path, value, id) => {
        this.props.updateInputs(path, value, id)
        this.props.updateInputs('addModificacion', true)
    }



    render() {

        const { solicitudBI, p_almacen, user_id, superusuario, enums, id, user, unidades } = this.props

        let responsable_almacen = "";
        if (p_almacen && p_almacen.count() > 0) {
            responsable_almacen = p_almacen.filter(a => a.get('ALMACEN') === this.props.tipo_almacen).getIn(['0', 'USUARIO']);
        }

        const esResponsableAlmacen = responsable_almacen == user_id
        const esResponsableCompras = solicitudBI.getIn(['responsable_compras', 'id']) == user.get('id')
        const esSuperusuario = user.get('es_superusuario')
        const estado = solicitudBI.get('estado')


        // const readOnly = (!esResponsableCompras && !esSuperusuario && !esResponsableAlmacen) || ((estado == 0) || ((estado != 1) && (estado != 8)) || ((estado > 2) && (estado != 8)))
        const readOnly = (!esResponsableCompras && !esSuperusuario && !esResponsableAlmacen) || (estado == 0) || (estado > 1)


        // const readOnly = true

        const actionsSectionDetallesBienes = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" onClick={e => this.props.addSolicitudBienesItem()} title="Adicionar bienes" disabled={ readOnly } />,
            // <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={this.borrarTabla()} title="Eliminar servicio" danger disabled={ solicitudBI.get('bienes') && !solicitudBI.get('bienes').filter(x => x.get('selected')).count() } />
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={e => this.props.removeSolicitudBienesItem()} title="Eliminar servicio" danger disabled={ solicitudBI.get('bienes') && !solicitudBI.get('bienes').filter(x => x.get('selected')).count() } />
        ]

        const disabled_comment = (estado === 0 || estado === 7);

        return (
            <div>
                <BoxSection title="Información básica">
                    <div className="row">

                        {
                            isAllowedToViewComponent('administrador', solicitudBI.get('solicitante')) && solicitudBI.get('estado') != 0 && solicitudBI.get('estado') != 7 ? (

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Solicitante</label>
                                        <SelectorInput value={solicitudBI.getIn(['solicitante', 'fullname']) || ''} onClick={() => this.handleOpenSelectorResponsable(`solicitud.solicitante`)} onReset={() => this.props.updateInputs(`solicitud.solicitante`, null)} />
                                    </div>
                                </div>

                            ) : (

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Solicitante</label>
                                            <input className="form-control input-sm" type="text" value={solicitudBI.getIn(['solicitante', 'fullname']) || ''} disabled />
                                        </div>
                                    </div>


                                )
                        }


                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input className="form-control input-sm" value={solicitudBI.getIn(['solicitante', 'email']) || ''} disabled />
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input className="form-control input-sm" type="text" value={solicitudBI.getIn(['solicitante', 'extension']) || ''} disabled />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Área</label>
                                <input className="form-control input-sm" type="text" value={solicitudBI.getIn(['solicitante', 'area', 'nombre']) || ''} disabled />
                            </div>
                        </div>
                        {
                            solicitudBI.get('documento_origen_id') && <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">Orden/Contrato</label>
                                    <input type="text" value={enums.documentos.tipos[solicitudBI.getIn(['documento_origen', 'tipo'])].PREFIJO + solicitudBI.getIn(['documento_origen', 'consecutivo']) || ''} className="form-control input-sm" disabled />
                                </div>
                            </div>
                        }
                    </div>


                    <div className="row">

                        {
                            isAllowedToViewComponent('administrador', solicitudBI.get('responsable_compras')) && solicitudBI.get('estado') != 0 && solicitudBI.get('estado') != 7 ? (

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="control-label">Responsable de compras</label>
                                        <SelectorInput value={solicitudBI.getIn(['responsable_compras', 'fullname']) || ''} onClick={() => this.handleOpenSelectorResponsable(`solicitud.responsable_compras`)} onReset={() => this.props.updateInputs(`solicitud.responsable_compras`, null)} />
                                    </div>
                                </div>

                            ) : (

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Responsable de compras</label>
                                            <input className="form-control input-sm" type="text" value={solicitudBI.getIn(['responsable_compras', 'fullname']) || ''} disabled />
                                        </div>
                                    </div>


                                )
                        }

                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input className="form-control input-sm" value={solicitudBI.getIn(['responsable_compras', 'email']) || ''} disabled />
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Extensión</label>
                                <input className="form-control input-sm" type="text" value={solicitudBI.getIn(['responsable_compras', 'extension']) || '' } disabled />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha solicitud</label>
                                <input className="form-control input-sm" value={moment(solicitudBI.getIn(['created_at'])).format('DD/MM/YYYY') || ''} disabled />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">No. Solicitud</label>
                                <input className="form-control input-sm" value={solicitudBI.get('id') || ''} disabled />
                            </div>
                        </div>


                    </div>
                </BoxSection>



                <BoxSection title="Información del bien solicitado">

                    <div className="row">


                        <div className="col-md-8">
                            <div className="form-group">
                                <label className="control-label">Proyecto/Evento/Actividad bienes</label>
                                <input type="text" value={solicitudBI.get('proyecto_evento') || ''} onChange={ (e) => this.modificarSolicitud('solicitud.proyecto_evento', e.target.value, id) } className="form-control input-sm" disabled={ readOnly } />
                            </div>
                        </div>


                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Almacén</label>
                                <select disabled={ readOnly } className="form-control input-sm" value={this.props.tipo_almacen}
                                onChange={e => this.modificarSolicitud('tipo_almacen', e.target.value, id)} >
                                    <option value="" disabled>Seleccione el almacén</option>
                                    <option value="Laboratorio">Laboratorio</option>
                                    <option value="Materiales">Materiales</option>
                                </select>
                            </div>
                        </div>


                        {

                            readOnly ? (

                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de entrega</label>
                                        <input type="text" disabled value={moment(solicitudBI.get('fecha_requerido')).format('YYYY/MM/DD') || ''} className="form-control input-sm" />
                                    </div>
                                </div>

                            ):(
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de entrega</label>
                                        <input className="form-control input-sm" type="date" value={moment(solicitudBI.get('fecha_requerido')).format('YYYY-MM-DD') || ''}  onChange={ (e) => this.modificarSolicitud('solicitud.fecha_requerido', e.target.value, id) }/>
                                    </div>
                                </div>
                            )
                        }



                    </div>
                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Detalle Bienes" actions={actionsSectionDetallesBienes} >

                    <table className="table table-condensed table-bordered table-striped table-sorted" id="table-solicitudes">
                    <thead>
                            <tr>
                                <th colSpan="3">Solicitante</th>
                                <th colSpan="2">Responsable almacén</th>
                            </tr>
                            <tr>
                                <th style={{ width: '20px' }}></th>
                                <th style={{ textAlign: 'center', width: '5%' }}>No.</th>
                                <th>Descripción bienes</th>

                                <th style={{ width: '15%' }}>Cantidad a solicitar</th>


                                <th style={{ width: '15%' }}>Unidad / Presentación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                solicitudBI.get('bienes') && solicitudBI.get('bienes').map((x, n) => {

                                    return (
                                        <tr key={x.get('id') ? x.get('id') : x.get('guid')} className={x.get('selected') ? 'info' : ''}>

                                            <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={x.get('selected') || false} onChange={e => this.props.updateInputs(`solicitud.bienes.${n}.selected`, e.target.checked)} disabled={ readOnly || n == 0 }/></td>

                                            <td style={{ textAlign: 'center' }} >{n + 1}</td>
                                            <td>
                                                <input defaultValue={ x.get('descripcion') || '' } className="form-control input-sm" onChange={e => this.modificarSolicitud(`solicitud.bienes.${n}.descripcion`, e.target.value, id)} disabled={readOnly}/>
                                            </td>

                                            <td>
                                                <input type="number" value={x.get('cantidad_solicitada') || '' } className="form-control input-sm" disabled={readOnly}
                                                    onChange={e => this.props.updateInputs(`solicitud.bienes.${n}.cantidad_solicitada`, e.target.value, id)} />
                                            </td>


                                            <td>
                                              {readOnly ? (
                                                <input value={x.get('unidad') || ""} className="form-control input-sm" disabled={true} />
                                              ) : (
                                                <select
                                                  className="form-control input-sm"
                                                  value={x.get('unidad') || ''}
                                                  onChange={e => this.props.updateInputs(`solicitud.bienes.${n}.unidad`, e.target.value, id)}
                                                >
                                                  <option value="">Seleccione unidad</option>
                                                  {unidades && unidades.map((unidad, idx) => (
                                                    <option key={idx} value={unidad.get('UNIDAD')}>{unidad.get('UNIDAD')}</option>
                                                  ))}
                                                </select>
                                              )}
                                            </td>


                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </BoxSection>


                <div className="separator"></div>
                <BoxSection title="Distribución de centros de costo">
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: '30%' }}>Responsable Cenco</th>
                                        <th style={{ width: '30%' }}>Cenco</th>
                                        <th style={{ width: '10%' }}>Porcentaje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        solicitudBI.getIn(['bienes', '0', 'cencos']) && solicitudBI.getIn(['bienes', '0', 'cencos']).map((x, n) => {
                                            return (
                                                <tr key={`tr[${x.get('id')}]`} className={x.get('selected') ? 'info-dark' : ''} >
                                                    <td style={{ width: '50%' }}>
                                                        <input disabled defaultValue={x.getIn(['usuario', 'fullname'])} className="form-control input-sm"/>
                                                    </td>

                                                    <td style={{ width: '30%' }}>
                                                        <input disabled defaultValue={x.get('codigo')} className="form-control input-sm"/>
                                                    </td>
                                                    <td>
                                                        <input disabled defaultValue={numeral(x.getIn(['pivot','porcentaje']) / 100).format('0%')}
                                                            className="form-control input-sm text-right"/>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </BoxSection>

                <div className="separator"></div>

                <BoxSection title="Observaciones">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea disabled className="form-control input-sm" rows={4} value={solicitudBI.get('observaciones')} />
                            </div>
                        </div>
                    </div>
                </BoxSection>

                <div className="separator"></div>

                <Comentarios
                    foros = { solicitudBI.get('foros') }
                    comentario = { this.props.comentario }
                    updateInputs = { this.props.updateInputs }
                    disabled_comment = { disabled_comment }
                    enviarComentario = { this.props.enviarComentario }
                    editarComentario = { this.props.editarComentario }
                    eliminarComentario = { this.props.eliminarComentario }
                />

                <div className="separator"></div>

                <AttachedFilesBox
                    files={ solicitudBI.get('adjuntos') }
                    removeFiles = { this.props.removeFiles }
                    updateInputs = { this.props.updateInputs }
                    obj={ solicitudBI }
                    check={ 'solicitud' }
                    root={ 'solicitud' }
                />

                <div className="separator"></div>

                <BoxSection title="Recomendaciones">
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-condensed table-bordered table-sorted" style={{ backgroundColor: '#eee' }}>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>SI EL EQUIPO REQUIERE ACCESORIOS (KIT DE HERRAMIENTAS O PARTES) ADICIONALES PARA SU FUNCIONAMIENTO, DEBE RELACIONARLO EN EL SIGUIENTE CUADRO</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>EN LA DESCRIPCIÓN DE LOS BIENES, FAVOR INDICAR MARCA, MODELO, CARACTERÍSTICAS Y ESPECIFICACIONES.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </BoxSection>

                <ModalAddFile
                    action={ () => this.props.addFile(`/files/${id}`, [() => this.props.getSolicitud(id)]) }
                />


                <ModalSelectorFromList />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        id: state.solicitudBI.get('id'),
        solicitudBI: state.solicitudBI.get('solicitud'),
        tipo_almacen: state.solicitudBI.get('tipo_almacen'),
        enums: state.common.get('enums').toJS(),
        p_almacen: state.common.getIn(['parametros', 'ALMACEN']),
        user_id: state.common.getIn(['user', 'username']),
        superusuario: state.common.getIn(['user', 'es_superusuario']),
        user: state.common.get('user'),
        comentario: state.solicitudBI.get('comentario'),
        unidades: state.common.getIn(['parametros', 'UNIDADES'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)),
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        addFile: (url, actions) => dispatch(addFile(url, actions)),
        removeFiles: () => dispatch(removeFiles()),
        addSolicitudBienesItem: () => dispatch(addSolicitudBienesItem()),
        removeSolicitudBienesItem: () => dispatch(removeSolicitudBienesItem()),
        enviarComentario: () => dispatch(enviarComentario()),
        editarComentario: (id) => dispatch(editarComentario(id)),
        eliminarComentario: (id) => dispatch(eliminarComentario(id)),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudBI)



// WEBPACK FOOTER //
// ./src/components/SolicitudBI/General.jsx